import { SKILLS } from "../data/content";
import { LineReveal, Rise } from "./motion/Reveal";

export const Skills = () => (
  <section id="skills" data-testid="skills-section" className="relative mx-auto max-w-[1400px] px-5 py-28 md:px-12 md:py-40">
    <div className="mb-16 flex items-end justify-between gap-4">
      <h2 className="font-display text-5xl font-extrabold uppercase tracking-tighter md:text-8xl">
        <LineReveal lines={["Capabilities"]} />
      </h2>
      <span className="hidden font-mono text-xs uppercase tracking-[0.3em] text-white/40 md:block">(Toolset)</span>
    </div>

    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {SKILLS.map((s, i) => (
        <Rise key={s.name} delay={i * 0.04}>
          <div
            data-testid={`skill-${s.name.replace(/\s+/g, "-").toLowerCase()}`}
            className="group flex items-center gap-4 rounded-2xl border border-white/10 p-6 transition-colors hover:border-electric/50"
          >
            <span className="font-mono text-xs text-electric">{String(i + 1).padStart(2, "0")}</span>
            <span className="flex-1 font-heading text-xl font-semibold text-cream transition-colors md:text-2xl">
              {s.name}
            </span>
            <span className="relative flex h-2.5 w-2.5">
              <span className="absolute inline-flex h-full w-full rounded-full bg-electric opacity-0 transition-opacity duration-500 group-hover:animate-ping group-hover:opacity-60" />
              <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-white/20 transition-colors group-hover:bg-electric" />
            </span>
          </div>
        </Rise>
      ))}
    </div>
  </section>
);
